{
  "header": {
    "title": "EZ Texting (Pilot)",
    "description": "Use Campanion to sync your contacts with EZ Texting."
  },
  "loading": "Loading content...",
  "blankSlate": "Add your first audience to EZ Texting.",
  "buttons": {
    "newGroup": "New Group",
    "sync": "Sync"
  },
  "state": {
    "syncing": "Syncing"
  },
  "columns": {
    "ezName": "EZ Texting Group Name",
    "audience": "Audience",
    "modified": "Date Modified",
    "synced": "Last Synced",
    "resultCount": "Sync Details"
  },
  "errors": {
    "loading": "There was a problem loading.",
    "loadingAction": "Please refresh to try again.",
    "deleteGroup": "Something went wrong deleting the group. Please try again."
  },
  "success": {
    "sync": "Request received. Syncing contacts may take some time."
  }
}
